"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useState } from "react";
import { Toaster } from "react-hot-toast";

export default function AppProviders({ children }) {
  const [client] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={client}>
      {children}
      <Toaster
        position="top-center"
        containerStyle={{ zIndex: 2147483647 }}
        toastOptions={{
          className: "text-xs",
          style: {
            background: "#030712",
            color: "#e5e7eb",
            border: "1px solid #1f2937",
          },
        }}
      />
    </QueryClientProvider>
  );
}
